import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { AutoCompleteItem } from 'types/api/Common/AutoCompleteTypes';
import { useGetCubeBaselineConnectionOptions } from 'services/v1/Tenant/AROCube/CubeDataEntryService';

interface PullBaseLineValueMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onClick: (value: AutoCompleteItem) => void;
  cubeId: string | undefined;
  cubeLayerId: string | undefined;
  cubeMemberId: string | undefined;
}

export default function PullBaseLineValueMenu(props: PullBaseLineValueMenuProps) {
  const { anchorEl, onClose, onClick, cubeId, cubeLayerId, cubeMemberId } = props;
  const { data: cubeBaselineConnectionOptions } = useGetCubeBaselineConnectionOptions(
    cubeId,
    cubeLayerId,
    cubeMemberId
  );
  const open = Boolean(anchorEl);

  const handleOnClick = (item: AutoCompleteItem) => {
    onClick(item);
    onClose();
  };
  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={onClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {cubeBaselineConnectionOptions?.data.connections.map((item) => (
          <MenuItem
            key={item.value}
            onClick={() => {
              handleOnClick(item);
            }}
          >
            Pull data from {item.label}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}
